import React, { useState } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { ui } from '../data/ui';
interface BeforeAfterSliderProps {
  before: string;
  after: string;
  caption: string;
  aspect?: string;
}
export function BeforeAfterSlider({
  before,
  after,
  caption,
  aspect = 'aspect-[4/3]'
}: BeforeAfterSliderProps) {
  const [position, setPosition] = useState(50);
  const {
    t
  } = useLanguage();
  return <div className={`group relative w-full overflow-hidden bg-navy ${aspect}`} data-id="element-23" data-mp="382lwykql435p">
      <img src={after} alt={`${caption} — ${t(ui.after)}`} className="absolute inset-0 h-full w-full object-cover" loading="lazy" data-id="element-24" data-mp="384pw6pdjgdzn" />
      <div className="absolute inset-y-0 left-0 overflow-hidden" style={{
      width: `${position}%`
    }} aria-hidden="true" data-id="element-25" data-mp="3i24d0q3dj4sh">
        <img src={before} alt="" className="absolute inset-0 h-full w-full max-w-none object-cover" style={{
        width: `calc(100% * ${100 / Math.max(position, 1)})`
      }} loading="lazy" data-id="element-26" data-mp="1nms3dlfyo9rs" />
      </div>

      <span className="pointer-events-none absolute left-3 top-3 rounded bg-navy-deep/85 px-2 py-1 text-[0.7rem] font-semibold uppercase tracking-[0.1em] text-white" data-id="element-27" data-mp="1dlh2ajlf14le">
        {t(ui.before)}
      </span>
      <span className="pointer-events-none absolute right-3 top-3 rounded bg-gold px-2 py-1 text-[0.7rem] font-semibold uppercase tracking-[0.1em] text-navy-deep" data-id="element-28" data-mp="1ncbnrlqu805s">
        {t(ui.after)}
      </span>

      <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white/90" style={{
      left: `${position}%`
    }} aria-hidden="true" data-id="element-29" data-mp="1w9uff8yzlcqn">
        <span className="absolute left-1/2 top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-navy shadow-lift" data-id="element-30" data-mp="269v131kbw4y0">
          <MoveHorizontalIcon className="h-4 w-4" aria-hidden="true" data-id="element-31" data-mp="bvk9ilccmwoj" />
        </span>
      </div>

      <input type="range" min={0} max={100} value={position} onChange={event => setPosition(Number(event.target.value))} className="ba-range absolute inset-0 h-full w-full cursor-ew-resize appearance-none bg-transparent" aria-label={`${caption} — ${t(ui.dragToCompare)}`} data-id="element-32" data-mp="3uwa8tn72axp" />
    </div>;
}